import React from 'react'
import { Avatar, Typography } from '@material-ui/core'
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles'
import { compose } from 'recompose'
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps'
import HeaderWithIconStyles from './HeaderWithIcon.styles'
import cn from 'classnames'

interface Props {
  icon: React.ReactNode,
  text: string,
}

type FProps = Props & WithGlobalStylesProps<any>

const HeaderWithIcon = (props: FProps) => {
  const {
    classes,
    icon,
    text,
  } = props

  return (
    <div className={classes.wrapper}>
      <div className={cn(classes.iconWrapper)}>
        <Avatar className={classes.avatar}>
          { icon }
        </Avatar>
      </div>
      <div>
        <Typography variant='h6' className={classes.text}>{ text }</Typography>
      </div>
    </div>
  )
}


export default compose<FProps, Props>(
  withGlobalStyles(HeaderWithIconStyles),
)(HeaderWithIcon)
